<template>
  <table class="table text-left">
    <tbody>
      <tr v-if="rowData.management_roles && rowData.management_roles.length">
        <td>
          <span
            v-for="(role, roleIndex) in rowData.management_roles"
            :key="roleIndex"
            class="role-wrapper"
          >
            <el-tag type="info" class="custom-tag">
              <div>
                <strong>{{ $t('common_words.name') }}:</strong>
                {{ role.name }}
              </div>
              <div>
                <strong>{{ $t('common_words.associated_users2') }}:</strong>
              </div>
              <div class="user-list">
                <span
                  v-for="(user, userIndex) in limitedUsers(
                    roleIndex,
                    role.users
                  )"
                  :key="userIndex"
                  class="user-item"
                >
                  - {{ user.name }}
                </span>
              </div>

              <div
                v-if="role.users && Object.keys(role.users).length > 5"
                class="show-more-container"
              >
                <el-button
                  type="text"
                  class="show-more-btn"
                  @click="toggleShowMore(roleIndex)"
                >
                  {{
                    expanded[roleIndex]
                      ? $t('common_words.see_less')
                      : $t('common_words.see_more')
                  }}
                </el-button>
              </div>
            </el-tag>
          </span>
        </td>
      </tr>
      <tr v-else>
        <td>
          <el-tag type="warning" effect="dark" class="mt-2">
            {{ $t('common_words.no_assignment') }}
          </el-tag>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'management-roles-dialog',
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      expanded: {}, // Controla qué roles están expandidos
    };
  },
  computed: {
    /**
     * Calcula el ancho de cada tag en función de la cantidad de roles administrativos
     */
    tagWidth() {
      const numRoles = this.rowData.management_roles
        ? this.rowData.management_roles.length
        : 0;
      if (numRoles === 0) return '100%';

      return `calc(${100 / numRoles}% - 8px)`; // Ajusta el tamaño dinámico
    },
  },
  methods: {
    /**
     * Muestra solo los primeros 5 usuarios, o todos si está expandido
     */
    limitedUsers(roleIndex, usersObject) {
      const users = usersObject ? Object.values(usersObject) : [];

      return this.expanded[roleIndex] ? users : users.slice(0, 5);
    },

    /**
     * Alterna entre mostrar solo 5 nombres o todos
     */
    toggleShowMore(roleIndex) {
      this.$set(this.expanded, roleIndex, !this.expanded[roleIndex]);
    },
  },
};
</script>

<style scoped>
/* Contenedor flexible para que los roles se distribuyan bien */
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px; /* Espacio entre los tags */
  justify-content: flex-start; /* Alinea los tags al inicio */
  width: 99%; /* Ocupar todo el ancho disponible */
}

/* Cada tag ocupa un ancho proporcional */
.tag-wrapper {
  flex-grow: 1;
  min-width: 150px;
}

/* Estilos para los tags */
.custom-tag {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between; /* Empuja el contenido y el botón "Ver más" hacia abajo */
  height: auto;
  width: 100%;
  word-wrap: break-word;
  white-space: normal;
  padding: 8px;
  position: relative;
}

/* Lista de usuarios dentro del tag */
.user-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 20px;
}

/* Espaciado para los nombres de usuario */
.user-item {
  display: inline-block;
  margin-right: 8px;
}

/* Contenedor del botón "Ver más", fijo en la parte inferior derecha */
.show-more-container {
  position: absolute;
  bottom: 0px;
  right: 10px;
}

/* Botón "Ver más" */
.show-more-btn {
  font-size: 12px;
  color: #39653b;
  cursor: pointer;
  text-decoration: underline;
}
</style>
